import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [{
    path: '/mathReport',
    component: () =>
      import('./views/math_report/mathRepot.vue'),
    children: [{
      path: '',
      component: () =>
        import('./views/math_report/entry.vue'),
      meta: {
        title: '学期数学掌握度'
      }
    },
    {
      path: 'detail',
      component: () =>
        import('./views/math_report/detail.vue'),
      meta: {
        title: '掌握度详情'
      }

    },
    {
      path: 'explain',
      component: () =>
        import('./views/math_report/explain.vue'),
      meta: {
        title: '掌握度说明'
      }
    }
    ]
  },
  {
    path: '/parentActive',
    component: () => import('./views/parent_active/parentActive.vue'),
    children: [
      {
        path: 'book_listen',
        component: () => import('./views/parent_active/bookListen.vue')
      },
      {
        path: 'get_prize',
        component: () => import('./views/parent_active/parentPrize.vue')
      },
      {
        path: 'download',
        component: () => import('./views/parent_active/downLoad.vue')
      },
      {
        path: 'self-study-area',
        component: () => import('./views/parent_active/selfStudyArea.vue'),
        meta: {
          title: '自学乐园'
        }
      },
      {
        path: 'dot-read-activity',
        component: () => import('./views/parent_active/dot_read/activity.vue')
      },
      {
        path: 'new-dot-read-activity',
        component: () => import('./views/parent_active/dot_read/activity.vue')
      },
      {
        path: 'dot-read-select-book',
        component: () => import('./views/parent_active/dot_read/selectBook.vue')
      },
      {
        path: 'school-package',
        component: () => import('./views/parent_active/newSchoolPackage.vue'),
      },
      {
        path: 'new-school-package',
        component: () => import('./views/parent_active/newSchoolPackage.vue'),
      },
      {
        path: 'package-select-dot-read',
        component: () => import('./views/parent_active/packageSelectDotRead.vue'),
      },
      {
        path: 'member-activity',
        component: () => import('./views/parent_active/memberActivity.vue'),
      },{
        path: 'new-prod',
        component: () => import('./views/parent_active/newProd.vue'),
        meta: {
          title: '会员新品类上新'
        }
      },
      {
        path: 'invite-parent',
        component: () => import('./views/parent_active/invite-parent/invite-parent.vue'),
        meta: {
          title: '邀请有礼'
        }
      },
    ]
  },
  {
    path: '/lightLesson',
    component: () => import('./views/light_lesson/entry.vue'),
    children: [
      {
        path: '',
        component: () => import('./views/light_lesson/lightLesson.vue'),
        meta: {
          title: '考前提升方案'
        }
      },
      {
        path: 'free_lesson',
        component: () => import('./views/light_lesson/freeLesson.vue'),
        meta: {
          title: '考前提升方案'
        }
      },
      {
        path: 'free_pay_sucess',
        component: () => import('./views/light_lesson/free_pay_sucess.vue'),
        meta: {
          title: '支付结果'
        }
      },
      {
        path: 'pay_sucess',
        component: () => import('./views/light_lesson/paySuccess.vue'),
        meta: {
          title: '支付结果'
        }
      },
      {
        path: 'parent_note',
        component: () => import('./views/light_lesson/parentNote.vue'),
        meta: {
          title: '家长笔记'
        }
      },
      {
        path: 'detail',
        component: () => import('./views/light_lesson/detail.vue'),
        meta: {
          title: '50元课'
        }
      },
      {
        path: 'common_sales',
        component: () => import('./views/light_lesson/common_sales.vue'),
        meta: {
          title: '通用售卖页'
        }
      }
    ]
  },
  {
    path: '/lesson',
    component: () => import('./views/parent_lesson/entry.vue'),
    children: [
      {
        path: '',
        component: () => import('./views/parent_lesson/select.vue'),
        meta: {
          title: ''
        }
      },
      {
        path: 'pay_sucess',
        component: () => import('./views/parent_lesson/paySucess.vue'),
        meta: {
          title: '支付结果'
        }
      },
      {
        path: 'lesson_active',
        component: () => import('./views/parent_lesson/details.vue'),
        meta: {
          title: '活动详情'
        }
      },
      {
        path: 'lesson_detail',
        component: () => import('./views/parent_lesson/lessonDetail.vue'),
        meta: {
          title: '课程详情'
        }
      },
      {
        path: 'program_list',
        component: () => import('./views/parent_lesson/programList.vue'),
        meta: {
          title: '课程大纲'
        }
      },
      {
        path: 'order_list',
        component: () => import('./views/parent_lesson/orderList.vue'),
        meta: {
          title: '我的订单'
        }
      },
      {
        path: 'order_detail',
        component: () => import('./views/parent_lesson/orderDetail.vue'),
        meta: {
          title: '订单详情'
        }
      }
    ]
  }, {
    path: '/group_buy',
    component: () => import('./views/group_buy/entry.vue'),
    children: [
      {
        path: 'app_detail',
        component: () => import('./views/group_buy/app_detail.vue'),
        meta: {
          title: '课程详情'
        }
      },
      {
        path: 'h5_detail',
        component: () => import('./views/group_buy/h5_detail.vue'),
        meta: {
          title: '课程详情'
        }
      },
      {
        path: 'course_list',
        component: () => import('./views/group_buy/course_list.vue'),
        meta: {
          title: '拼团课程'
        }
      },
      {
        path: 'group_detail',
        component: () => import('./views/group_buy/group_detail.vue'),
        meta: {
          title: '拼团详情'
        }
      }, {
        path: 'follow',
        component: () => import('./views/group_buy/follow.vue'),
        meta: {
          title: '拼团成功'
        }
      }, {
        path: 'download',
        component: () => import('./views/group_buy/download.vue'),
        meta: {
          title: '拼团成功'
        }
      }, {
        path: 'group_activity',
        component: () => import('./views/group_buy/group_activity.vue'),
        meta: {
          title: '拼团'
        }
      }
    ]
  }, {
    path: '/member',
    component: () => import('./views/member/entry.vue'),
    children: [
      {
        path: 'member_ios',
        component: () => import('./views/member/member_ios.vue'),
        meta: {
          title: '开通会员'
        }
      },
      {
        path: 'member_and',
        component: () => import('./views/member/member_and.vue'),
        meta: {
          title: '开通会员'
        },
      },
      {
        path: 'member_new',
        component: () => import('./views/member/member_new.vue'),
        meta: {
          title: '开通会员'
        }
      },
      {
        path: 'picture_page',
        component: () => import('./views/member/picture_page.vue'),
        meta: {
          title: '开通会员'
        }
      },
      {
        path: 'picture_page_listen',
        component: () => import('./views/member/picture_page_listen.vue'),
        meta: {
          title: '开通会员'
        }
      },
      {
        path: 'member_equity_new',
        component: () => import('./views/member/member_equity_new.vue'),
        meta: {
          title: '开通会员'
        }
      },
      {
        path: 'member_limited_one',
        component: () => import('./views/member/member_limited_one.vue'),
        meta: {
          title: '小盒会员超值特惠'
        }
      },
      {
        path: 'membership',
        component: () => import('./views/member/membership.vue'),
        meta: {
          title: '热门好课上新'
        }
      },
      {
        path: 'membership_june',
        component: () => import('./views/member/membership_june.vue'),
        meta: {
          title: '同步练'
        }
      },
      {
        path: 'member_card',
        component: () => import('./views/member/member_card.vue'),
        meta: {
          title: '开通会员'
        }
      },
      {
        path: 'membership_june_02',
        component: () => import('./views/member/membership_june_02.vue'),
        meta: {
          title: '三大学习“神器”'
        }
      },
      // {
      //   path: 'pay_help_ios',
      //   component: () => import('./views/member/pay_help_ios.vue'),
      //   meta: {
      //     title: 'Iphone支付帮助'
      //   }
      // },
      {
        path: 'common_problems',
        component: () => import('./views/member/common_problems.vue'),
        meta: {
          title: '常见问题'
        }
      },
      {
        path: 'pay_help_ios',
        component: () => import('./views/member/pay_help_ios.vue'),
        meta: {
          title: '支付帮助'
        }
      },
      {
        path: 'upgrade_rule_ios',
        component: () => import('./views/member/upgrade_rule_ios.vue'),
        meta: {
          title: '升级规则'
        }
      },
      {
        path: 'upgrade_rule_and',
        component: () => import('./views/member/upgrade_rule_and.vue'),
        meta: {
          title: '升级规则'
        }
      }
      ,
      {
        path: 'no_pay_popup',
        component: () => import('./views/member/no_pay_popup.vue'),
        meta: {
          title: '弹窗'
        }
      },
      {
        path: 'member_xufei',
        component: () => import('./views/member/member_xufei.vue'),
        meta: {
          title: '自动续费协议'
        }
      },
      {
        path: 'aiclass_member_xufei',
        component: () => import('./views/member/aiclass_member_xufei.vue'),
        meta: {
          title: '自动续费协议'
        }
      },
      {
        path: 'member_service_agreement',
        component: () => import('./views/member/member_service_agreement.vue'),
        meta: {
          title: '会员服务协议'
        }
      },
      
    ]
  },
  {
    path: '/card',
    component: () => import('./views/parent_card/card.vue'),
    children: [
      {
        path: 'refundProgress',
        component: () => import('./views/refund/refundProgress.vue'),
        meta: {
          title: '申请退费'
        }
      }, 
      {
        path: 'logistics',
        component: () => import('./views/parent_card/logistics.vue'),
        meta: {
          title: '物流'
        }
      }, 
      {
        path: 'studyProgress',
        component: () => import('./views/parent_card/studyProgress.vue'),
        meta: {
          title: '学习进度'
        }
      },  
      {
        path: 'refund',
        component: () => import('./views/refund/applyRefund.vue'),
        meta: {
          title: '申请退费'
        }
      }, 
      {
        path: 'questionTip',
        component: () => import('./views/parent_card/questionTip.vue'),
        meta: {
          title: '常见问题'
        }
      },    
    ]
  },
  {
    path: '/address',
    component: () => import('./views/address/address.vue'),
  }
  ]
})
